import { useEffect, useState } from 'react';
import { apiClient } from '@/lib/api';
import { useAuth } from '@/features/auth/hooks/use-auth';

type Entorno = 'prod' | 'dev' | 'local';

/**
 * L4 (vault 277, PD-30): una cinta arriba de todo cuando la pantalla NO es PROD. Se
 * auditaron capturas de DEV creyendo que eran de PROD; con la cinta no vuelve a pasar.
 * Lo decide el servidor (por el nombre de su base); si no responde, no se inventa nada.
 * Ronda E (ENT-1): el nombre de la base es dato de la plataforma — la cinta lo muestra
 * sólo a un PLATFORM_ADMIN (y el servidor ya no lo devuelve a nadie más).
 * El servidor también puede apagarla (`cinta: false`, 26-oct): DEV se usa para
 * mostrarle Prixia a clientes.
 */
interface EstadoDelEntorno {
  entorno: Entorno;
  baseDeDatos: string | null;
  cinta?: boolean;
}

export function CintaDeEntorno() {
  const { user } = useAuth();
  const [estado, setEstado] = useState<EstadoDelEntorno | null>(null);

  useEffect(() => {
    let vivo = true;
    apiClient
      .get<EstadoDelEntorno>('/api/entorno')
      .then((r) => {
        if (vivo) setEstado(r);
      })
      .catch(() => {
        if (vivo) setEstado(null);
      });
    return () => {
      vivo = false;
    };
  }, []);

  if (!estado || estado.entorno === 'prod' || estado.cinta === false) return null;
  const rotulo = estado.entorno === 'dev' ? 'DEV' : 'LOCAL';
  const esAdminDePlataforma = user?.role === 'PLATFORM_ADMIN';
  return (
    <div
      role="status"
      className="w-full bg-amber-400 px-4 py-1 text-center text-xs font-bold tracking-wide text-amber-950"
    >
      {rotulo} — no es PROD
      {esAdminDePlataforma && estado.baseDeDatos ? ` · base ${estado.baseDeDatos}` : ''}
    </div>
  );
}
